import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DataAccessFairsFacade } from '@planone/bau365/data-access-fair-data';
import { Event as EventInterface, Exhibitor } from '@planone/bau365/util-fair-data';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'bau365-event-section-details',
  templateUrl: './section-details.component.html',
  styleUrls: ['./section-details.component.scss'],
})
export class SectionDetailsComponent implements OnInit, OnDestroy {
  @Input() event?: EventInterface;
  @Input() exhibitor?: Exhibitor;

  timezone?: string;

  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(private FairsFacade: DataAccessFairsFacade) {}

  ngOnInit() {
    this.FairsFacade.fairConfig$.pipe(takeUntil(this.unsubscribe)).subscribe((fair) => (this.timezone = fair.timezone));
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
